import { ORDER_URL } from "../content";
import { trackCustom } from "../analytics/metaPixel";

export default function BuyButton({ testid, className = "", children = "Kupuję kurs", location = "unknown" }) {
  return (
    <a
      href={ORDER_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => trackCustom("ClickCTA", { location })}
      className={`inline-flex min-h-[48px] items-center justify-center rounded-full bg-[#FF008B] px-8 py-3 text-base font-bold text-white shadow-lg shadow-[#FF008B]/25 transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#D90077] hover:shadow-xl hover:shadow-[#FF008B]/30 ${className}`}
    >
      {children}
    </a>
  );
}
